import {
  GET_SKU_TEST_PACKAGES_DETAILS,
  GET_HVCHARGESFOR_DETAILS,
  GET_TESTTYPE_DETAILS,
  GET_PROVIDERLIST_DETAIL,
  GET_TAGLIST_NETWORK,
  GET_PACKAGE_TAGLIST_NETWORK,
  GET_FACILITY_DROPDOWNlIST
} from "../../Utils/types";

const initialState = {
  getSkuTestPackagesDetails: null,
  getHVChargesForDetails: null,
  getTestTypeDetails: null,
  getProviderListNetworkDetails: [],
  getTagListNetworkDetails: [],
  getPackageTagListNetworkDetails: [],
  getFacilityDropdownList:[]
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SKU_TEST_PACKAGES_DETAILS:
      return {
        ...state,
        getSkuTestPackagesDetails: action.payload,
      };
    case GET_HVCHARGESFOR_DETAILS:
      return {
        ...state,
        getHVChargesForDetails: action.payload,
      };
    case GET_TESTTYPE_DETAILS:
      return {
        ...state,
        getTestTypeDetails: action.payload,
      };
    case GET_PROVIDERLIST_DETAIL:
      return {
        ...state,
        getProviderListNetworkDetails: action.payload,
      };
    case GET_TAGLIST_NETWORK:
      return {
        ...state,
        getTagListNetworkDetails: action.payload,
      };
    case GET_FACILITY_DROPDOWNlIST:
      return {
        ...state,
        getFacilityDropdownList: action.payload,
      };
    case GET_PACKAGE_TAGLIST_NETWORK:
      return {
        ...state,
        getPackageTagListNetworkDetails: action.payload,
      };
    default:
      return state;
  }
};
